<h1 mat-dialog-title>Undo</h1>
<div mat-dialog-content>
  <div [class.half-scale]="isMobile$ |async">
    <app-status [broadcast]="undoPreview" [preview]="true" [manual]="true"></app-status>
  </div>
  <h3>Now at manual index: {{previewIndex}}</h3>
</div>
<div mat-dialog-actions>
  <button mat-stroked-button (click)="undo()">
    <mat-icon>undo</mat-icon>
    Undo
  </button>
  <button mat-stroked-button (click)="redo()">
    <mat-icon>redo</mat-icon>
    Redo
  </button>
  <button mat-stroked-button (click)="close()">Close</button>
  <button mat-stroked-button (click)="confirm()" cdkFocusInitial>Confirm</button>
</div>
